import { render } from "./UnRegisterTournamentDialog.vue?vue&type=template&id=48b3ba00"
import script from "./UnRegisterTournamentDialog.vue?vue&type=script&lang=js"
export * from "./UnRegisterTournamentDialog.vue?vue&type=script&lang=js"

import exportComponent from "/Users/andreaskura/repos/cio-online-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__